import React from 'react'
import Switch from 'react-bootstrap-switch'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { ReviewContentBox } from '../../components'
import { updateBadgeInfo } from '../actions'

const ReviewContentLayout = props => {
  let chosenChapterIds = new Set(props.selectedChapters.map(c => c))
  let chosenVideoIds = new Set(props.selectedVideos.map(v => v))

  const filteredChapters = props.chapters.filter(c =>
    chosenChapterIds.has(c.id)
  )
  const filteredVideos = props.videos.filter(v => chosenVideoIds.has(v.id))
  const filteredAssessments = props.selectedAssessments.map(
    element => props.assessments[element]
  )

  const toggleBadgePrereqs = () => {
    props.updateInfo({ requireNewPrereqs: !props.requireNewPrereqs })
  }

  return (
    <div id="outer_requirements">
      <ReviewContentBox
        title="Required Assessments"
        subtitle={`Students must pass the following assessments with a score of at least ${props.passingScore}%:`}
      >
        {filteredAssessments.map((a, id) => {
          return <div key={id}>{a}</div>
        })}
      </ReviewContentBox>
      <ReviewContentBox
        title="Required Reading"
        subtitle="Students must complete the following reading:"
      >
        {filteredChapters.map(c => (
          <div key={c.id}>{c.title}</div>
        ))}
      </ReviewContentBox>
      <ReviewContentBox
        title="Required Videos"
        subtitle="Students must complete the following videos:"
      >
        {filteredVideos.map(v => (
          <div key={v.id}>{v.title}</div>
        ))}
      </ReviewContentBox>
      <h3 className="review_header">Badge Description</h3>
      <div className="data_container review_content_container">
        <div>{props.description}</div>
      </div>
      {props.retrievedEditData ? (
        <div>
          <h3 className="review_header">Require New Prereqs if Earned</h3>
          <h5 className="review_header">
            Set to &quot;Yes&quot; to require new prerequisites retroactively
          </h5>
          <div className="data_container review_content_container">
            <Switch
              value={props.requireNewPrereqs}
              onChange={toggleBadgePrereqs}
              onColor={'success'}
              offColor={'danger'}
              labelWidth={53}
              handleWidth={49}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>
      ) : (
        <div />
      )}
    </div>
  )
}

ReviewContentLayout.propTypes = {
  passingScore: PropTypes.string,
  getAssessments: PropTypes.func,
  selectedAssessments: PropTypes.array,
  assessments: PropTypes.object,
  selectedChapters: PropTypes.array,
  chapters: PropTypes.array,
  videos: PropTypes.array,
  selectedVideos: PropTypes.array,
  description: PropTypes.string,
  retrievedEditData: PropTypes.bool.isRequired,
  requireNewPrereqs: PropTypes.bool.isRequired,
  updateInfo: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    passingScore: state.badgeInfo.passingScore,
    selectedAssessments: state.badgeInfo.selectedAssessments,
    selectedChapters: state.badgeInfo.selectedChapters,
    selectedVideos: state.badgeInfo.selectedVideos,
    assessments: state.assessments,
    chapters: state.chapters.chapterChoices,
    videos: state.videos.videoChoices,
    description: state.badgeInfo.description,
    retrievedEditData: state.badgeInfo.retrievedEditData,
    requireNewPrereqs: state.badgeInfo.requireNewPrereqs,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateInfo: badgeInfo => {
      dispatch(updateBadgeInfo(badgeInfo))
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReviewContentLayout)
)
